module.exports = {"data":{"one":[{"txt":"Pos Code","val":"P00001"},{"txt":"Project Code","val":"Neo S"},{"txt":"Fixture Owner","val":"adidas"},{"txt":"Operation Period","val":"3 years"},{"txt":"First Open Date","val":"2018-01-08"},{"txt":"Closure Apply Date","val":"2021-07-13"},{"txt":"Closure MPSA(K)","val":"50"},{"txt":"Close Reason","val":"MPSA Issue"},{"txt":"Detail Reason","val":"Long time low MPSA"},{"txt":"Remark","val":"It's up to requestor.And ok to be blank."}],"two":[{"name":"KA Account Head","value":758},{"name":"SHJ VP","value":429},{"name":"SHJ VP","value":429},{"name":"RE VP","value":256}]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/adidas.json
// module id = GMvd
// module chunks = 1